import * as React from 'react';
import { Provider, useSelector } from "react-redux";
import { DiaryRootState } from "appRoot/rootReducer";
import LoginRoot from "appRoot/LoginRoot";
import BookingsRoot from "appRoot/BookingsRoot";
import ReactUtilsService from "external-services/react-utils-service";
import store from "appRoot/Store";
import { IntlProvider } from "react-intl/dist";
import { LocaleService } from 'app/services/locale/locale.service';
import AppThemeService from 'app/services/theme/appTheme.service';
import { StylesProvider, ThemeProvider } from '@material-ui/core/styles';
import { useEffect } from "react";
import MainViewVisibilityService from "app/services/mainViewVisibility";
import { PouchLoadStatus } from 'app/actions/pouch.actions';
import GlobalViews from 'appRoot/GlobalViews';
import { bookingActions } from 'app/reducers/booking/slice';
const theme = AppThemeService.getAppTheme();

// Make store available on window for legacy AngularJS integration
if (typeof window !== 'undefined') {
  (window as any).store = store;
}
export enum appRoutes {
  login = 'login',
  bookings = 'bookings',
  setup = 'setup',
  oauth2 = 'oauth2',
}

const RouteView = () => {

  const routeStatus = useSelector((state: DiaryRootState) => state.rootDisplayReducer.routeStatus);
  const pouchLoadedStatus = useSelector((state: DiaryRootState) => state.pouchReducer.pouchLoadedStatus);

  useEffect(() => {
    LocaleService.configureMomentLocale();
  }, []);

  useEffect(() => {
    if (routeStatus !== appRoutes.bookings) {
      store.dispatch(bookingActions.cleanupPouchListeners()); // NBI-8701: cleanup pouch listeners when not on bookings page
      MainViewVisibilityService.clearBodyCssClassNames();
    }
  }, [routeStatus]);

  return (
    <>
      {(routeStatus === appRoutes.login || routeStatus === appRoutes.oauth2) && <LoginRoot />}
      {routeStatus === appRoutes.bookings && pouchLoadedStatus === PouchLoadStatus.success && <BookingsRoot />}
      <GlobalViews />
    </>
  )
}

export const RouteManager = () => {

  return (
    ReactUtilsService.containerWrap(
      <StylesProvider injectFirst>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <IntlProvider locale={LocaleService.getLocale()}>
              <RouteView />
            </IntlProvider>
          </Provider>
        </ThemeProvider>
      </StylesProvider>
    )
  );
}
